import prop1 from "../assets/pic4.jpeg";
import prop2 from "../assets/pic5.jpeg";
import prop3 from "../assets/pic6.jpeg";

const Carddata = [
  {
    id:1,
    imgsrc: prop1,
    title: "IT staffing",
    content: "We provide exclusive on-demand services in recruitment process outsourcing and professional staffing for businesses who are in need of senior-level developers with specific technology expertise and industry specialized experience."
  },
  {
    id:2,
    imgsrc: prop2,
    title: "IT Solutions",
    content: "We provide technology solutions for a wide range of industries to optimize performance in major business areas and maximize returns on their technology investments."
  },
  {
    id:3,
    imgsrc: prop3,
    title: "Consulting",
    content: "We provide comprehensive IT consulting services that can help you meet your business goals. For more information, contact us!"
  },
];

export default Carddata;
